(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"), require("vuex"));
	else if(typeof define === 'function' && define.amd)
		define("platform", ["vue", "vuex"], factory);
	else if(typeof exports === 'object')
		exports["platform"] = factory(require("vue"), require("vuex"));
	else
		root["platform"] = factory(root["Vue"], root["Vuex"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__127__, __WEBPACK_EXTERNAL_MODULE__285__) {
return 